import { useEffect, useRef, useState } from "react";

import { AvField, AvForm } from "availity-reactstrap-validation";
import { Label, Modal, ModalBody, ModalHeader } from "reactstrap";

import { toast } from "react-toastify";

import * as _service from "../../service/payments.service";
import { dateConverter, getDate, getTime, timeConverter } from "../../helpers/functions";

const Followup = ({ isOpen, onToggle, id }) => {
  const formRef = useRef();

  const date = getDate();
  const time = getTime();

  const initialState = { date, time };

  const [data, setData] = useState({});
  const [masterObject, setMasterObject] = useState({ ...initialState });

  useEffect(() => {
    if (isOpen && id) handleData();
  }, [isOpen, id]); // eslint-disable-line

  const handleData = async () => {
    try {
      const response = await _service.details(id);
      const { data, payments = [] } = response;
      setData({ ...data, payments });
    } catch (error) {
      console.error(error);
      onToggle();
    }
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      // const method = masterObject.id ? _service.update : _service.create;
      const response = await _service.addPayment({ ...masterObject, id });

      toast.success(response.message);
      reset();
    } catch (error) {
      console.error(error);
      toast.error(error?.message);
    }
  };

  const handleValueChange = ({ name, value }) => {
    setMasterObject((prev) => ({ ...prev, [name]: value }));
  };

  const reset = () => {
    formRef.current.reset();
    setMasterObject({ ...initialState });
    handleData();
  };

  return (
    <Modal isOpen={isOpen} centered size="lg" toggle={onToggle}>
      <ModalHeader toggle={onToggle}>Add Payments - {data.boat || data.name || ""}</ModalHeader>
      <ModalBody>
        <div className="mb-4">
          {data.dueAmount > 0 ? (
            <AvForm ref={formRef} onValidSubmit={handleSubmit}>
              <div className="row">
                <div className="col-4 col-md-3">
                  <Label>Date</Label>
                  <AvField
                    type="date"
                    name="date"
                    onChange={(e) => handleValueChange(e.target)}
                    placeholder="Date"
                    errorMessage="Enter Date"
                    validate={{ required: { value: true } }}
                    value={masterObject.date || ""}
                    defaultValue={masterObject.date || ""}
                  />
                </div>
                <div className="col-4 col-md-3">
                  <Label>Time</Label>
                  <AvField
                    type="time"
                    name="time"
                    onChange={(e) => handleValueChange(e.target)}
                    placeholder="Time"
                    errorMessage="Enter Time"
                    validate={{ required: { value: true } }}
                    value={masterObject.time || ""}
                    defaultValue={masterObject.time || ""}
                  />
                </div>
                <div className="col-4 col-md-3">
                  <Label>Amount (Due: {data.dueAmount || ""})</Label>
                  <AvField
                    type="number"
                    name="amount"
                    placeholder="Amount"
                    onChange={(e) => handleValueChange(e.target)}
                    errorMessage="Enter Amount"
                    validate={{
                      required: { value: true },
                      min: { value: 1, errorMessage: "Amount must be valid" },
                    }}
                    value={masterObject.amount || ""}
                    defaultValue={masterObject.amount || ""}
                  />
                </div>

                <div className="col-md-3 mb-3 d-flex gap-2 form-button">
                  <button className="btn btn-submit">Submit</button>
                </div>
              </div>
            </AvForm>
          ) : (
            ""
          )}
          {data.payments?.length > 0 && (
            <div className="mt-4">
              <div className="table-responsive rounded border">
                <table className="table table-sm table-hover align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: "40%" }}>Date</th>
                      <th className="text-end">Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.payments.map((payment, idx) => (
                      <tr key={idx}>
                        <td className="text-muted small text-center">
                          {dateConverter(payment.date)}
                          {", "}
                          {timeConverter(payment.time)}
                        </td>
                        <td className="text-end fw-semibold text-success small">
                          {Number(payment.amount).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
        <div className="d-flex justify-content-end mt-4">
          <button className="btn btn-secondary" onClick={onToggle}>
            Close
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Followup;
